/** @jsx jsx */
import { jsx } from "theme-ui";
import { StaticQuery, graphql } from "gatsby";
import { Link } from "gatsby";
// import { GatsbyImage } from "gatsby-plugin-image";
// import sanityConfig from "../../../sanityConfig";
// import { getGatsbyImageData } from "gatsby-source-sanity";
import Burger from "./burger";
import React, { useState } from "react";

function returnSubMenuImage(image) {
  //switched to normal image for now. GatsbyImage was causing onMouseLeave to fire.
  // const gatsbyImageData = getGatsbyImageData(
  //   image,
  //   { maxWidth: 600 },
  //   sanityConfig
  // );
  return <img src={image.asset.url} alt="Topics" />;
}

const Menu = () => {
  const [subMenuState, setSubMenuState] = useState([false, false]);
  const [clicked, setClicked] = useState("0");
  const handleToggle = (index) => {
    if (clicked === index) {
      return setClicked("0");
    }
    setClicked(index);
  };
  const [desktopMenuPopup, setDesktopMenuPopup] = useState(false);
  const [menuState, setMenuState] = useState(false);
  const toggleMenu = () => {
    let newState = !menuState;
    setMenuState(newState);
    setDesktopMenuPopup(newState);
  };

  return (
    <StaticQuery
      query={graphql`
        query MenuQuery {
          submenu: sanityPageDefinition(slug: { current: { eq: "topics" } }) {
            _rawEntities(resolveReferences: { maxDepth: 10 })
          }
          mobileLogo: file(name: { eq: "evp-logo-dark" }) {
            publicURL
          }
          logo: file(name: { eq: "Everplans-Logo-White" }) {
            publicURL
          }
        }
      `}
      render={(data) => (
        <div
          sx={{
            padding: ["44px 0px 15px 0px", "20px 0px"],
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link
            sx={{
              width: "136px",
              display: "flex",
            }}
            to="/"
            onFocus={() => setDesktopMenuPopup(false)}
          >
            <img src={data.logo.publicURL} alt="Everplans Logo" />
          </Link>
          <Burger clickMe={(e) => toggleMenu()} open={menuState} />
          <div
            sx={{
              width: ["calc(100% - 106px)", "calc(100% - 136px)"],
              display: [menuState ? "block" : "none", "block", "block"],
            }}
          >
            <nav aria-label="Everplans">
              <ul
                role="menubar"
                aria-label="Everplans"
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  margin: "0px",
                  padding: "0px",
                  li: {
                    listStyle: "none",
                    lineHeight: "1.5",
                  },
                }}
              >
                <li
                  className="menuitem"
                  role="none"
                  sx={{
                    fontSize: "1rem",
                    marginRight: ["0rem", "4rem"],
                  }}
                >
                  <a
                    href="#"
                    role="menuitem"
                    aria-haspopup="true"
                    aria-expanded={desktopMenuPopup}
                    onMouseEnter={() => setDesktopMenuPopup(true)}
                    onMouseLeave={() => setDesktopMenuPopup(false)}
                    onClick={() => setDesktopMenuPopup(true)}
                    sx={{
                      color: "#ffffff",
                      textDecoration: "none",
                      alignItems: "center",
                      cursor: "pointer",
                      height: "100%",
                      padding: "10px 20px 10px 0px",
                      display: [menuState ? "block" : "none", "flex"],
                      "> div": {
                        display: [
                          menuState ? "block" : "none",
                          desktopMenuPopup ? "block" : "none",
                        ],
                      },
                    }}
                  >
                    <span
                      sx={{
                        display: ["none", "flex"],
                      }}
                    >
                      Organize your life
                    </span>
                    <span
                      sx={{
                        position: "relative",
                        paddingLeft: "7px",
                        bottom: "4px",
                        display: ["none", "block"],

                        "&:before": {
                          content: "''",
                          width: "0",
                          height: "0",
                          borderLeft: "6px solid transparent",
                          borderRight: "6px solid transparent",
                          borderTop: "7px solid #ffffff",
                          position: "absolute",
                        },
                      }}
                    ></span>
                    {data.submenu._rawEntities && (
                      <div
                        sx={{
                          display: [menuState ? "block" : "none", "none"],
                          width: ["100%", "500px"],
                          height: ["auto", "405px"],
                          minHeight: ["100vh", "auto"],
                          cursor: "initial",
                          position: ["fixed", "absolute"],
                          right: ["0", "100px"],
                          top: ["0px", "55px"],
                          margin: ["0px", "0px 2.5rem"],
                          zIndex: "5",
                          bottom: "0",
                          overflowY: "hidden",
                          overflowX: "hidden",
                          paddingTop: ["0px", "20px"],
                        }}
                      >
                        <div
                          sx={{
                            width: "100%",
                            height: ["auto", "100%"],
                            minHeight: ["100vh", "auto"],
                            display: ["block", "flex"],
                            backgroundColor: "white",
                            borderRadius: ["0px", "24px"],
                            border: "1px solid",
                            borderWidth: ["0px", "1px"],
                            borderColor: "primary",
                            padding: ["44px 0px", "35px 55px"],
                            boxSizing: "border-box",
                            justifyContent: "space-between",

                            "&:before": {
                              content: "''",
                              width: "0",
                              height: "0",
                              borderLeft: "6px solid transparent",
                              borderRight: "6px solid transparent",
                              borderBottom: "7px solid #ffffff",
                              position: "absolute",
                              top: "15px",
                              left: "275px",
                              display: ["none", "block"],
                            },
                          }}
                        >
                          <div
                            sx={{
                              display: ["block", "none"],
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            <Link
                              to="/"
                              sx={{
                                img: {
                                  width: "136px",
                                },
                              }}
                            >
                              <img
                                src={data.mobileLogo.publicURL}
                                alt="Everplans Logo"
                              />
                            </Link>
                          </div>
                          <div
                            className="sub-menu-container"
                            sx={{
                              width: ["100%", "100%)"],
                              height: ["100%", "calc(100% - 20px)"],
                              marginTop: ["10px", "0px"],
                              paddingTop: ["30px", "0px", "0px"],
                              borderTop: ["1px solid", "0px solid"],
                              borderColor: "primary",
                            }}
                          >
                            <div
                              sx={{
                                width: "calc(100%)",
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "wrap",
                                height: "100%",
                              }}
                            >
                              {data.submenu._rawEntities.map(
                                (menuItem, index) => (
                                  <React.Fragment key={index}>
                                    {menuItem._type ==
                                      "categoryTopicDisplay" && (
                                      <div
                                        sx={{
                                          width: ["100%", "calc(50% - 20px)"],
                                          "&:nth-child(1)": {
                                            marginBottom: ["0px", "20px"],
                                          },
                                          "&:nth-child(2)": {
                                            marginBottom: ["0px", "0px"],
                                          },
                                          "&:nth-child(3)": {
                                            marginBottom: ["0px", "20px"],
                                            marginLeft: ["0px", "40px"],
                                          },
                                          "&:nth-child(4)": {
                                            marginLeft: ["0px", "40px"],
                                          },
                                        }}
                                      >
                                        <h2
                                          sx={{
                                            fontWeight: "500 !important",
                                            fontSize: ["1.4rem", "1.125rem"],
                                            marginBottom: ["0px", "3px"],
                                            marginTop: "0px",
                                            color: "primary",
                                            position: "relative",
                                            cursor: ["pointer", "default"],
                                            padding: ["10px 25px", "0px"],
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            "&:after": {
                                              borderStyle: "solid",
                                              borderWidth: "2px 2px 0 0",
                                              content: "''",
                                              height: "0.45em",
                                              left: "0.15em",
                                              position: "relative",
                                              top: "-0.15em",
                                              transform:
                                                clicked === index
                                                  ? "rotate(135deg)"
                                                  : "rotate(45deg)",
                                              verticalAlign: "top",
                                              width: "0.45em",
                                              display: ["inline-block", "none"],
                                            },
                                          }}
                                          onClick={() => handleToggle(index)}
                                        >
                                          {menuItem.category.name}
                                        </h2>
                                        <ul
                                          role="menu"
                                          aria-label={menuItem.category.name}
                                          aria-expanded={subMenuState[index]}
                                          aria-haspopup={menuState}
                                          sx={{
                                            display: [
                                              clicked === index
                                                ? "block"
                                                : "none",
                                              "block",
                                            ],
                                            padding: [
                                              "20px 25px 10px 25px",
                                              "0px",
                                            ],
                                            backgroundColor: [
                                              "primary",
                                              "transparent",
                                            ],
                                            margin: ["0px 0px 20px 0px", "0px"],
                                          }}
                                        >
                                          {menuItem.topics.map(
                                            (topicItem, subIndex) => (
                                              <li
                                                key={subIndex}
                                                role="none"
                                                sx={{
                                                  listStyle: "none",
                                                  marginBottom: ["10px", "0px"],
                                                }}
                                              >
                                                <Link
                                                  role="menuitem"
                                                  sx={{
                                                    fontSize: [
                                                      "1.4rem",
                                                      "0.875rem",
                                                    ],
                                                    display: "block",
                                                    fontWeight: "light",
                                                    color: [
                                                      "#ffffff",
                                                      "primary",
                                                    ],
                                                    textDecorationThickness:
                                                      "1px",
                                                    textDecoration: "none",
                                                    marginBottom: [
                                                      "10px",
                                                      "0px",
                                                    ],
                                                    ":hover": {
                                                      textDecoration:
                                                        "underline",
                                                    },
                                                    "&:last-child": {
                                                      marginBottom: "0px",
                                                    },
                                                  }}
                                                  to={
                                                    "/" + topicItem.slug.current
                                                  }
                                                >
                                                  {topicItem.name}
                                                </Link>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    )}
                                  </React.Fragment>
                                )
                              )}
                              <Link
                                sx={{
                                  fontWeight: "500 !important",
                                  fontSize: ["1.4rem", "1.75rem"],
                                  display: ["inline-block", "none"],
                                  padding: "0px 25px",
                                  marginTop: "15px",
                                }}
                                to="/topics"
                              >
                                View All
                              </Link>
                            </div>
                            <Link
                              sx={{
                                fontWeight: "500 !important",
                                fontSize: "0.875rem",
                                textDecoration: "none",
                                borderColor: "primary",
                                display: ["none", "inline"],
                                borderBottom: "2px solid",
                              }}
                              to="/topics"
                            >
                              View All
                            </Link>
                            <a
                              sx={{
                                variant: "buttons.primaryWhite",
                                display: [
                                  menuState ? "block !important" : "none",
                                  "none",
                                ],
                                margin: "35px 25px 20px 25px",
                                textAlign: "center",
                                fontSize: "1rem",
                              }}
                              href="https://webapps.everplans.com/#/auth/sign_in"
                              onFocus={() => setDesktopMenuPopup(false)}
                            >
                              Log in
                            </a>
                            <a
                              role="menuitem"
                              sx={{
                                variant: "buttons.primaryBlue",
                                display: [
                                  menuState ? "block !important" : "none",
                                  "none",
                                ],
                                margin: "0px 25px",
                                textAlign: "center",
                                fontSize: "1rem",
                              }}
                              href="https://webapps.everplans.com/#/auth/sign-up"
                            >
                              Sign up
                            </a>
                          </div>
                        </div>
                      </div>
                    )}
                  </a>
                </li>
                <li
                  className="menuitem"
                  role="none"
                  sx={{
                    position: "relative",
                  }}
                >
                  <a
                    sx={{
                      color: "#ffffff",
                      textDecoration: "none",
                      display: "inline-block",
                      fontSize: "0.875rem",
                      borderRadius: "1.5rem",
                      bg: "primary",
                      padding: [".2rem 1.1rem", ".5rem 2rem"],
                      textDecoration: "none",
                      border: "thin solid white",
                      ":hover": {
                        bg: "primaryDark",
                      },
                    }}
                    href="https://webapps.everplans.com/#/auth/sign_in"
                    onFocus={() => setDesktopMenuPopup(false)}
                  >
                    Log in
                  </a>
                </li>
                <li
                  className="menuitem"
                  role="none"
                  sx={{
                    position: "relative",
                    marginLeft: "1rem",
                  }}
                >
                  <a
                    role="menuitem"
                    sx={{
                      textDecoration: "none",
                      display: "inline-block",
                      fontSize: "0.875rem",
                      borderRadius: "1.5rem",
                      color: "primary",
                      bg: "white",
                      padding: [".2rem 1.1rem", ".5rem 2rem"],
                      textDecoration: "none",
                      border: "thin solid white",
                      ":hover": {
                        bg: "primaryDark",
                        color: "white",
                      },
                    }}
                    href="https://webapps.everplans.com/#/auth/sign-up"
                  >
                    Sign up
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    />
  );
};

export default Menu;
